import { CircularProgress, Link } from '@mui/material'
import { generateBillOfLading } from 'controllers/outboundTrips/index'
import { useState } from 'react'

interface DownloadOutboundBillOfLadingLinkProps {
  disabled?: boolean
  outboundTripGuid: string
}

export default function DownloadOutboundBillOfLadingLink({ disabled, outboundTripGuid }: DownloadOutboundBillOfLadingLinkProps) {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  return (
    <Link
      onClick={() => {
        if (disabled || isSubmitting) return

        setIsSubmitting(true)
        generateBillOfLading(outboundTripGuid, 'download').finally(() => setIsSubmitting(false))
      }}
      sx={{ cursor: disabled ? 'not-allowed' : isSubmitting ? 'wait' : 'pointer' }}
    >
      {isSubmitting ? <CircularProgress size={16} /> : 'Download Outbound Bill Of Lading'}
    </Link>
  )
}
